import {
  Component,
  Input,
  TemplateRef,
  ViewChild,
  AfterViewInit
} from '@angular/core';

@Component({
  selector: 'db-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss']
})
export class TabComponent implements AfterViewInit {
  @Input() label: string = '';
  
  @ViewChild('tabContent', { static: true })
  content: TemplateRef<any>;

  ngAfterViewInit() {
    // Component initialized
  }

  constructor() { }

}
